(function () {
    'use strict';

    angular
        .module('cacmEventEditModule')
        .controller('CacmEventEditController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'cacmEvent', 'cacmService'];

    function Controller($scope, topBarService, cacmEvent, cacmService) {
        topBarService.setTitleAndIcon('CACM Events', 'fa fa-bullseye');

        $scope.cacmEvent = cacmEvent;

        $scope.refreshCacmEvent = function (/*{CACMEvent, CACMEventFollowUps}*/refreshParam) {
            if (refreshParam && refreshParam.CACMEvent) {
                _.merge($scope.cacmEvent, refreshParam.CACMEvent);
            } else {
                cacmService.getCacmEvent($scope.cacmEvent.CACMEventID).then(function (event) {
                    _.merge($scope.cacmEvent, event);
                });
            }
        };

        $scope.getFollowUpsForEvent = function (/*{CACMEvent, CACMEventFollowUps}*/refreshParam) {
            if (refreshParam && refreshParam.CACMEventFollowUps) {
                var syncedFollowUps = syncFollowUps($scope.followUpModel.followUps, refreshParam.CACMEventFollowUps);
                if (typeof syncedFollowUps === 'boolean' && syncedFollowUps) {
                    $scope.followUpModel = {followUps: refreshParam.CACMEventFollowUps};
                } else {
                    $scope.followUpModel = {followUps: syncedFollowUps};
                }
            } else {
                cacmService.getFollowUpsForEvent(cacmEvent.CACMEventID).then(function (followUps) {
                    if (!followUps) {
                        followUps = [];
                    }
                    $scope.followUpModel = {followUps: followUps};
                });
            }
        };

        // Download attachment
        $scope.getDownloadAttachmentUrl = function (attachmentId) {
            return cacmService.getDownloadAttachmentUrl(
                $scope.cacmEvent.CACMEventID,
                attachmentId);
        };

        $scope.getFollowUpsForEvent();

        cacmService.getDataPointForEvent(cacmEvent.CACMEventID).then(function (events) {
            $scope.childrenEvents = events;
        });

        function syncFollowUps(toSync, newArray) {
            // Find start of shift
            var shift = indexOfWith(newArray, toSync[0], 'FollowUpID');

            if (shift < 0) shift = 1;

            var needsRefresh = false;

            _.forEachRight(toSync, function (item, index) {
                if (!item.IsSubmitted) {
                    var a = newArray[index + shift];
                    if (a.FollowUpID !== item.FollowUpID || a.IsSubmitted === true) {
                        needsRefresh = true;
                    }
                }
            });
            if (!needsRefresh) {
                for (var i = shift - 1; i > -1; --i) {
                    toSync.unshift(newArray[i]);
                }
            }
            return needsRefresh || toSync;
        }

        /**
         * Index of an item in an array using a property for comparison
         *
         * @param {Array} array The array to iterate through
         * @param {Object} value The object to compare to
         * @param {String} property The property on the object to compare with
         * @returns {number} index of the found object or -1
         */
        function indexOfWith(array, value, property) {
            if (_.isUndefined(value) || value === null) return -1;
            for(var i = 0; i < array.length; ++i) {
                if(array[i][property] === value[property]) {
                    return i;
                }
            }
            return -1;
        }
    }
})();